module.exports = __webpack_public_path__ + "static/media/multi_cont.f1bb1210.png";